export function getFocusableElements(
	parentElement: Element
): NodeListOf<HTMLElement> {
	return parentElement.querySelectorAll(
		'button, [href], [tabindex]:not([tabindex="-1"])'
	)
}
